export default class Login {
    constructor() {
        this.userName = "";
        this.email = "";
        this.password = "";
    }
}